import { forwardRef, useRef } from 'react'

const Button = forwardRef(function Button({ className = '', as = 'button', disabled, children, ...props }, ref) {
    const internalRef = useRef()
    const buttonRef = ref || internalRef
    const Component = as

    return (
        <Component
            {...props}
            className={`flex items-center justify-center cursor-pointer rounded-lg border py-2 px-6 transition hover:bg-opacity-90 ${
                disabled ? 'opacity-25 cursor-not-allowed' : ''
            } ${className}`}
            disabled={disabled}
            ref={buttonRef}
        >
            {children}
        </Component>
    )
})

export default Button
